import React from "react";
import ShareIcons from "./ShareIcons";
import Image from "next/image";
import FormatDate from "@/utils/FormatDate";
import ReadingTime from "@/utils/ReadingTime";
import BlogCard_Thumbnail from "@/assets/image/BlogCard_Thumbnail.jpg";
import { getReadingTime } from "@/helpers/readingTime";
import Link from "next/link";
const ArticleImageBlock = ({
  article,
  articleUrl,
  articleTitle,
  articleAltTitle,
}) => {
  const {
    category,
    subcategories,
    title,
    author,
    updatedAt,
    blocks,
    cover,
    blogDate,
    view_count,
  } = article || {};

  const imageUrl =
    cover?.url ||
    cover?.formats?.large?.url ||
    cover?.formats?.medium?.url ||
    BlogCard_Thumbnail;

  return (
    <div className="bg-[#dee9f2]">
      <div className="px-[var(--container-padding)] max-w-[var(--max-page-width)] mx-auto py-[30px] flex flex-col-reverse gap-[16px] md:gap-12 lg:flex lg:flex-row md:py-[35px] lg:gap-[90px]">
        <div className="w-full my-auto">
          {/* Category */}
          {category && (
            <span
              className="font-medium text-sm leading-[100%] tracking-[0] text-[#EB9100] bg-[#FFF0D7] py-[3px] px-[8px] mb-[10px] inline-block mr-[10px]"
              style={{ fontFamily: "saans-medium" }}
            >
              {category.name}
            </span>
          )}

          {subcategories?.name && (
            <span
              className="font-medium text-sm leading-[100%] tracking-[0] text-[#2563EB] bg-[#EAF2FF] py-[3px] px-[8px] mb-[10px] inline-block"
              style={{ fontFamily: "saans-medium" }}
            >
              {subcategories.name}
            </span>
          )}

          {/* Title */}
          <h1 className="text-[24px] leading-[30px] tracking-normal align-middle mb-[17px] lg:text-[30px] lg:mb-[26px] lg:leading-[38px]">
            {title || "Untitled Article"}
          </h1>

          <hr
            className="mb-[17px] lg:hidden"
            style={{ border: "1px solid #D7DFE6" }}
          ></hr>

          {/* Author */}
          {author && (
            <div className="mb-[21px] lg:mb-[15px]">
              {author?.slug ? (
                <Link href={`/author/${author.slug}`}>
                  <p
                    className="text-[16px] leading-[14.4px] tracking-normal align-middle"
                    style={{ fontFamily: "saans-medium" }}
                  >
                    By{" "}
                    {author?.name ||
                      author?.attributes?.name ||
                      author?.data?.attributes?.name}
                  </p>
                </Link>
              ) : (
                <p
                  className="text-[16px] leading-[14.4px] tracking-normal align-middle"
                  style={{ fontFamily: "saans-medium" }}
                >
                  By{" "}
                  {author?.name ||
                    author?.attributes?.name ||
                    author?.data?.attributes?.name}
                </p>
              )}
            </div>
          )}

          <hr
            className="hidden lg:block"
            style={{ border: "1px solid #D7DFE6" }}
          ></hr>

          <div className="lg:flex justify-between items-center mt-[15px]">
            <div className="flex items-center gap-[10px] text-sm text-gray-600 mb-[33px] lg:mb-[0]">
              {/* {updatedAt && (
                <p
                  className="text-[14px] leading-[14.4px] tracking-normal align-middle"
                  style={{ fontFamily: "saans-regular" }}
                >
                  {FormatDate(updatedAt)}
                </p>
              )} */}

              {(blogDate || updatedAt) && (
                <p
                  className="text-[14px] leading-[14.4px] tracking-normal align-middle"
                  style={{ fontFamily: "saans-regular" }}
                >
                  {blogDate ? `Updated: ${FormatDate(blogDate)}` : `Updated: ${FormatDate(updatedAt)}`}
                </p>
              )}

              {/* <span className="w-[4px] h-[4px] bg-[#63778B] rounded-full"></span>

              {view_count && (
                <p
                  className="text-[14px] leading-[14.4px] tracking-normal align-middle"
                  style={{ fontFamily: "saans-regular" }}
                >
                  {view_count} views
                </p>
              )} */}

              <span className="w-[4px] h-[4px] bg-[#63778B] rounded-full"></span>
              <span>
                {getReadingTime(
                  (article.blocks || [])
                    .map((block) => block.Editor || block.body || "")
                    .join(" "),
                )}
              </span>
            </div>
            <ShareIcons
              alignment={"flex gap-[20px]"}
              articleUrl={articleUrl}
              articleTitle={articleTitle}
            />
          </div>
        </div>

        {/* Image */}
        {imageUrl && (
          <div className="relative w-full lg:mb-8">
            <Image
              src={imageUrl}
              alt={articleAltTitle || "Article Image"}
              width={1200}
              height={800}
              className="object-cover"
              aspect-ratio="4/3"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticleImageBlock;
